import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sexoPipe'
})

export class SexoPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) {
      return '';
    }
    return Number(value)  ===  1 ? 'Masculino' : 'Feminino';
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/sexo.pipe.ts